export default __webpack_public_path__ + "static/media/Logo.077b0aca.png";